import React, { useState } from 'react';
import DocumentMeta from 'react-document-meta';
import { Link, useHistory } from 'react-router-dom';
import Cart from '../components/Cart';
import ShopCard from '../components/ShopCard';
import products from '../data/shopProducts';
import useCart from '../hooks/useCart';
import styles from '../styles/Shop.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

const shopCategories = [
  { id: 'artisan-bread', label: 'Artisan bread' },
  { id: 'breakfast', label: 'Breakfast' },
  { id: 'lunch-grill', label: 'Lunch & Grill' },
];

const Shop = () => {
  const history = useHistory();
  const {
    items,
    addItem: addToCart,
    changeQuantity,
    removeItem,
    itemCount,
  } = useCart();
  const [activeCategory, setActiveCategory] = useState('artisan-bread');

  const visibleProducts = products.filter(product => product.categoryId === activeCategory);

  const meta = {
    title: 'Shop | Grain Bites',
    description: 'Order homemade artisan bread and pastries from Grain Bites.',
  };

  return (
    <DocumentMeta {...meta}>
      <main className={styles.page}>
        <header className={styles.hero}>
          <p className={styles.eyebrow}>Order from the oven</p>
          <h1>Artisan bread shop</h1>
          <p>Fresh bread and pastries, prepared for local pickup and delivery.</p>
          <Link className={styles.cartLink} to={`${publicUrl}/Cart`}>
            View cart{itemCount > 0 ? ` (${itemCount})` : ''}
          </Link>
        </header>

        <section className={styles.shopArea} aria-labelledby="shop-title">
          <div className={styles.intro}>
            <p className={styles.label}>Freshly made</p>
            <h2 id="shop-title">Choose your bread</h2>
            <p>Pre-order your favourites and choose a convenient collection or delivery time.</p>
          </div>

          <nav className={styles.categories} aria-label="Shop categories">
            {shopCategories.map(category => (
              <button
                className={activeCategory === category.id ? styles.activeCategory : styles.category}
                key={category.id}
                type="button"
                aria-pressed={activeCategory === category.id}
                onClick={() => setActiveCategory(category.id)}
              >
                {category.label}
              </button>
            ))}
          </nav>

          <div className={styles.shopLayout}>
            <div className={styles.productsArea}>
              {visibleProducts.length > 0 ? (
                <div className={styles.products}>
                  {visibleProducts.map(product => (
                    <ShopCard key={product.id} product={product} onAdd={addToCart} />
                  ))}
                </div>
              ) : (
                <div className={styles.emptyCategory}>
                  <h2>Lunch &amp; Grill</h2>
                  <p>Fresh lunch and grill options will be added soon.</p>
                </div>
              )}
            </div>
            <Cart
              items={items}
              onChangeQuantity={changeQuantity}
              onRemove={removeItem}
              onCheckout={() => history.push(`${publicUrl}/PlaceOrder`)}
            />
          </div>
        </section>
      </main>
    </DocumentMeta>
  );
};

export default Shop;
